import React, { Component } from "react";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { TbMessages } from "react-icons/tb";
import { FiPhoneCall } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import Image2 from "../../image/john.jpg"
import Image3 from "../../image/christian.jpg"
import { FaLinkedinIn } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";
import { FaFacebookF } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaSquareThreads } from "react-icons/fa6";
import ProfileMapComponent from "../../part/location.map.profiile";

class TutorDashcontact extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        courses: [],
        contact: "lagos"
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);





    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };


    handleContactchange = (value) => {
        this.setState({
            contact: value
        })
    }


    render() {
        const { menuCoverWidth } = this.state;

        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)` }}>

                    <div className="dash_contact">
                        <h2><span>Inquiry</span><br />Contact Us </h2>
                        <nav className="filter">
                            <button onClick={() => { this.handleContactchange("lagos") }}>Lagos Branch</button>
                            <button onClick={() => { this.handleContactchange("abuja") }}>Abuja Branch</button>
                        </nav>


                        {this.state.contact === 'lagos' ?
                            <div className="container active" >
                                <div className="contain">
                                    <section className="content">
                                        <section className="top">
                                            <div className="image"><img src={Image2} alt="service" /></div>
                                            <div className="content">
                                                <h4>Mr  John Abodunwa  <br /><span>Training Coordinator</span></h4>
                                                <a href="sms:+2347070708909"><button><TbMessages /> Message</button></a>
                                                <a href="tel:+2347070708909"><button><FiPhoneCall /></button></a>
                                                <a href="https://wa.me/2347070708909?text=Hello%20Geoinfo%20Academy,%20I’m%20interested%20in%20your%20training%20programs"><button><FaWhatsapp /></button></a>
                                            </div>
                                        </section>
                                        <section className="body">
                                            <section className="cover">
                                                <div className="headline">
                                                    <h5>Bio</h5>
                                                </div>
                                                <div className="writeup">
                                                    <p>I am a GIS Analyst and Training Coordinator with a deep passion for spatial data analysis,
                                                        geospatial technology, and capacity building. My training approach emphasizes real-world applications,
                                                        collaborative learning, and continuous professional growth.</p>
                                                </div>
                                            </section>
                                            <section className="cover">
                                                <div className="headline">
                                                    <h5>Email</h5>
                                                </div>
                                                <div className="writeup">
                                                    <li>Training@geoinfotech.ng <button>Primary</button></li>
                                                    {/* <li>contact@geoinfotech.ng</li> */}
                                                </div>
                                            </section>
                                            <section className="cover">
                                                <div className="headline">
                                                    <h5>Phone</h5>
                                                </div>
                                                <div className="writeup">
                                                    <li>0707 070 8909 <button>Primary</button></li>
                                                    <li>0813 410 1202</li>
                                                    <li>0702 688 1563</li>
                                                    <li>0816 322 2177</li>
                                                </div>
                                            </section>

                                            <section className="cover">
                                                <div className="headline">
                                                    <h5>Address</h5>
                                                </div>
                                                <div className="writeup">
                                                    <a href="https://maps.app.goo.gl/c4M19ToKXhMuQVSJ7?g_st=ic"  rel="noreferrer" ><li>Geoinfotech, Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos.</li></a>
                                                </div>
                                            </section>


                                            <section className="cover">
                                                <div className="headline">
                                                    <h5>Socials</h5>
                                                </div>
                                                <div className="writeup">
                                                    <a href="https://web.facebook.com/profile.php?id=61560061085346"><p className="socials"><FaFacebookF /></p></a>
                                                    <a href="https://www.linkedin.com/company/106275604/admin/dashboard/" ><p className="socials"><FaLinkedinIn /></p></a>
                                                    <a href="https://www.instagram.com/geoinfoacademy/"><p className="socials"><FaInstagram /></p></a>
                                                    <a href="https://x.com/AcademyGeo10178"><p className="socials"><RiTwitterXFill /></p></a>
                                                    <a href="https://www.tiktok.com/@geoinfoacademy"><p className="socials"><FaTiktok /></p></a>
                                                    <a href="https://www.threads.net/@geoinfoacademy"><p className="socials"><FaSquareThreads /></p></a>
                                                    <a href="https://www.youtube.com/channel/UCB0XOeYndWC9WyT87x_nRew"><p className="socials"><FaYoutube /></p></a>
                                                </div>
                                            </section>
                                        </section>
                                    </section>


                                    <section className="map">
                                        <ProfileMapComponent venue="Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos" />
                                    </section>
                                </div>
                            </div>
                            : null}




                        {this.state.contact === 'abuja' ?
                            <div className="container active" >
                                <div className="contain">
                                    <section className="top">
                                        <div className="image"><img src={Image3} alt="service" /></div>
                                        <div className="content">
                                            <h4>Mrs Christiana Ayelagbe <br /><span>GIS Analyst and Facilitator</span></h4>
                                            <a href="sms:+2349018724833"><button><TbMessages /> Message</button></a>
                                            <a href="tel:+2349018724833"><button><FiPhoneCall /></button></a>
                                            <a href="https://wa.me/2349018724833?text=Hello%20Geoinfo%20Academy,%20I’m%20interested%20in%20your%20training%20programs"><button><FaWhatsapp /></button></a>
                                        </div>
                                    </section>
                                    <section className="body">
                                        <section className="cover">
                                            <div className="headline">
                                                <h5>Bio</h5>
                                            </div>
                                            <div className="writeup">
                                                <p>As a Facilitator and GIS Analyst at Geoinfotech, I am your point of contact for any issues or complaints. Please feel free to reach out to me.</p>
                                            </div>
                                        </section>
                                        <section className="cover">
                                            <div className="headline">
                                                <h5>Email</h5>
                                            </div>
                                            <div className="writeup">
                                                <li>Training@geoinfotech.ng<button>Primary</button></li>
                                                {/* <li></li> */}
                                            </div>
                                        </section>
                                        <section className="cover">
                                            <div className="headline">
                                                <h5>Phone</h5>
                                            </div>
                                            <div className="writeup">
                                                <li>0901 872 4833<button>Primary</button></li>
                                                <li>0813 410 1202</li>
                                                <li>0702 688 1563</li>
                                                <li>0816 322 2177</li>
                                                <li>0707 070 8909</li>
                                            </div>
                                        </section>

                                        
                                        <section className="cover">
                                                <div className="headline">
                                                    <h5>Address</h5>
                                                </div>
                                                <div className="writeup">
                                                    <a href="https://maps.app.goo.gl/HsVwjEeLa9gg4C4Y7?g_st=aw" rel="noreferrer" ><li>2nd floor Puskin mall, Samuel Mafuyi Street, Opposite AA Rano, Jabi, Abuja </li></a>
                                                </div>
                                            </section>

                                        <section className="cover">
                                            <div className="headline">
                                                <h5>Socials</h5>
                                            </div>
                                            <div className="writeup">
                                                <a href="https://web.facebook.com/profile.php?id=61560061085346"><p className="socials"><FaFacebookF /></p></a>
                                                <a href="https://www.linkedin.com/company/106275604/admin/dashboard/" ><p className="socials"><FaLinkedinIn /></p></a>
                                                <a href="https://www.instagram.com/geoinfoacademy/"><p className="socials"><FaInstagram /></p></a>
                                                <a href="https://x.com/AcademyGeo10178"><p className="socials"><RiTwitterXFill /></p></a>
                                                <a href="https://www.tiktok.com/@geoinfoacademy"><p className="socials"><FaTiktok /></p></a>
                                                <a href="https://www.threads.net/@geoinfoacademy"><p className="socials"><FaSquareThreads /></p></a>
                                                <a href="https://www.youtube.com/channel/UCB0XOeYndWC9WyT87x_nRew"><p className="socials"><FaYoutube /></p></a>
                                            </div>
                                        </section>
                                    </section>



                                    <section className="map">
                                        <ProfileMapComponent venue="2nd floor Puskin mall, Samuel Mafuyi Street, Opposite AA Rano, Jabi, Abuja" />
                                    </section>
                                </div>
                            </div>
                            : null}
                    </div>

                    <FooterDashboard />
                    <Policy />
                </div>
            </div>
        )
    }
}

export default TutorDashcontact